import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=caecebb4&"
import script from "./EventInfo.vue?vue&type=script&lang=js&"
export * from "./EventInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports